module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2946d5a288356584985cf180be715a9a.png";